import { createTheme } from '@mui/material/styles';

// Site theme for the 2026 redesign. Colors and fonts mirror the fi- design
// system in src/assets/styles/fi.css: ink borders, hard offset shadows, square
// corners, Anton for big headings, Archivo for everything else.
const INK = '#111111';
const POP = '#FFE600';
const DISPLAY = "'Anton', Impact, 'Arial Narrow', sans-serif";
const BODY = "'Archivo', system-ui, -apple-system, 'Segoe UI', sans-serif";

const displayHeading = { fontFamily: DISPLAY, fontWeight: 400, textTransform: 'uppercase', lineHeight: 1, letterSpacing: '0.005em' };

const theme = createTheme({
  palette: {
    primary: { main: INK, contrastText: '#fff' },
    secondary: { main: POP, contrastText: INK },
    error: { main: '#D7140F' },
    info: { main: '#1748E8' },
    success: { main: '#2E7D32' },
    text: { primary: INK, secondary: '#333333' },
    background: { default: '#fff', paper: '#fff' },
    divider: INK,
  },
  shape: { borderRadius: 0 },
  typography: {
    fontFamily: BODY,
    h1: displayHeading,
    h2: displayHeading,
    h3: displayHeading,
    h4: { fontWeight: 800 },
    h5: { fontWeight: 800 },
    h6: { fontWeight: 800 },
    button: { fontWeight: 800 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 0, fontWeight: 800 },
        contained: {
          border: `2px solid ${INK}`,
          boxShadow: `4px 4px 0 ${INK}`,
          '&:hover': { boxShadow: `6px 6px 0 ${INK}` },
        },
        outlined: { borderWidth: 2, '&:hover': { borderWidth: 2 } },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 0, border: `3px solid ${INK}`, boxShadow: `6px 6px 0 ${INK}` },
      },
    },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 0 } } },
    MuiChip: { styleOverrides: { root: { borderRadius: 0, fontWeight: 700 } } },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          '& .MuiOutlinedInput-notchedOutline': { borderWidth: 2, borderColor: INK },
        },
      },
    },
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: 0, border: `3px solid ${INK}`, boxShadow: `10px 10px 0 ${INK}` } },
    },
    MuiAccordion: { styleOverrides: { root: { borderRadius: 0 } } },
  },
});

export default theme;
